import { motion } from "framer-motion";
import { ArrowRight, TrendingUp, Users, Zap } from "lucide-react";

const WHATSAPP_LINK = "https://api.whatsapp.com/send/?phone=553182934076&text=Ol%C3%A1%2C+gostaria+de+mais+informa%C3%A7%C3%B5es+sobre+gest%C3%A3o+de+tr%C3%A1fego+para+empresas+locais.&type=phone_number&app_absent=0";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
};

const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const highlights = [
  { icon: Users, text: "Mais clientes" },
  { icon: TrendingUp, text: "Crescimento previsível" },
  { icon: Zap, text: "Resultados reais" },
];

export const HeroSection = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center hero-gradient overflow-hidden"
    >
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#2563EB]/10 rounded-full blur-[128px]" />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-[#10B981]/5 rounded-full blur-[100px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-32 lg:py-40">
        <motion.div
          variants={staggerContainer}
          initial="initial"
          animate="animate"
          className="text-center max-w-4xl mx-auto"
        >
          {/* Label */}
          <motion.div
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8"
          >
            <span className="w-2 h-2 bg-[#10B981] rounded-full animate-pulse" />
            <span className="text-[#A1A1AA] text-sm font-medium tracking-wide">
              Gestão Profissional de Tráfego Pago
            </span>
          </motion.div>

          {/* Main Headline */}
          <motion.h1
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="font-outfit font-bold text-4xl sm:text-5xl lg:text-7xl text-white leading-[1.1] tracking-tight mb-6"
          >
            Pare de depender de indicação e{" "}
            <span className="text-gradient-blue">comece a receber clientes</span>{" "}
            todos os dias
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="text-[#A1A1AA] text-base lg:text-lg max-w-2xl mx-auto mb-10 leading-relaxed"
          >
            Gestão profissional de tráfego pago para empresas que querem crescer com
            previsibilidade e aumentar o faturamento de forma consistente.
          </motion.p>

          {/* CTA Button */}
          <motion.div
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="mb-16"
          >
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-button"
              className="inline-flex items-center gap-3 bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors duration-200 cta-glow btn-pulse"
            >
              Agendar Reunião Gratuita
              <ArrowRight className="w-5 h-5" />
            </a>
          </motion.div>

          {/* Highlights */}
          <motion.div
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="flex flex-wrap justify-center gap-6 lg:gap-10"
          >
            {highlights.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-2 text-[#A1A1AA]"
              >
                <item.icon className="w-5 h-5 text-[#2563EB]" />
                <span className="text-sm font-medium">{item.text}</span>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#050505] to-transparent" />
    </section>
  );
};
